// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media print {\n  .page {\n    padding-left: 0.7em;\n  }\n}\n.page h4 {\n  color: #da5936;\n  font-size: 1em;\n  font-weight: normal;\n  margin-left: 1em;\n  padding: 1em;\n}\n.page h4 a {\n  color: #da5936;\n}\n.page h4 a:hover {\n  text-decoration: underline;\n}\n@media print {\n  .page h4 {\n    color: #000;\n    margin-left: 0;\n    margin-bottom: 0.4em;\n    padding: 0;\n    font-size: 1.15em;\n    font-weight: normal;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
